import { useContext, useMemo } from 'react';
import { CompanyContext } from '@/_contexts/admin/CompanyProvider';

/**
 * @param bulkSelectedEntityTypes - Categories of entities, e.g., 'Individual', 'Partnership', 'C-Corp', etc.
 * @param selectedCompanyIds - Individually-selected entity IDs
 * @returns Total count of entities from the selected categories, or the number of selected entities
 */
export const useEntityCount = ({
  bulkSelectedEntityTypes,
  selectedCompanyIds,
}: {
  bulkSelectedEntityTypes: Array<string>;
  selectedCompanyIds: Array<number>;
}) => {
  const { entityTypeCounts } = useContext(CompanyContext);

  return useMemo(() => {
    if (bulkSelectedEntityTypes?.length && entityTypeCounts) {
      return bulkSelectedEntityTypes.reduce(
        (sum, type) => sum + (entityTypeCounts[type] ?? 0),
        0,
      );
    }
    return selectedCompanyIds?.length ?? 0;
  }, [bulkSelectedEntityTypes, entityTypeCounts, selectedCompanyIds?.length]);
};
